import { View } from '@gluestack-ui/themed'
import React, { FunctionComponent } from 'react'
import { StyleSheet } from 'react-native'
import { ViewProps } from '../../../redux/theme/types'

export const Content: FunctionComponent<ViewProps> = ({ style, ...props }) => <View style={[styles.content, style]} {...props} />

const styles = StyleSheet.create({
  content: {
    // flex: 1,
    // width: '100%',
  },
})
